import { createLucideIcon } from 'lucide-react'

export const JavaScript = createLucideIcon('JavaScript', [
  [
    'path',
    {
      d: 'M2 2H22V22H2V2Z',
      key: '1',
      fill: '#F0DB4F',
      strokeWidth: '0',
    },
  ],
  [
    'path',
    {
      d: 'M20.3631 17.23C20.2167 16.3175 19.6217 15.5513 17.8593 14.8365C17.2472 14.5551 16.5646 14.3536 16.3612 13.8897C16.289 13.6198 16.2795 13.4677 16.3251 13.3042C16.4563 12.7738 17.0894 12.6084 17.5913 12.7605C17.9144 12.8688 18.2205 13.1179 18.4049 13.5152C19.2681 12.9563 19.2662 12.9601 19.8688 12.5761C19.6483 12.2339 19.5304 12.076 19.3859 11.9297C18.8669 11.3498 18.1597 11.0513 17.0285 11.0742C16.8327 11.0989 16.635 11.1255 16.4392 11.1502C15.8745 11.2928 15.3365 11.5894 15.0209 11.9867C14.0741 13.0609 14.3441 14.9411 15.4962 15.7148C16.6312 16.5666 18.2985 16.7605 18.5114 17.5571C18.7186 18.5323 17.7947 18.8479 16.8764 18.7358C16.1996 18.5951 15.8232 18.251 15.4164 17.6255C14.6673 18.059 14.6673 18.059 13.8974 18.5019C14.0799 18.9012 14.2719 19.0818 14.578 19.4278C16.0266 20.8974 19.6521 20.8251 20.3023 18.6008C20.3289 18.5247 20.5038 18.0152 20.3631 17.23ZM12.8726 11.192H11.0019C11.0019 12.808 10.9943 14.4125 10.9943 16.0285C10.9943 17.057 11.0475 18 10.8802 18.289C10.6065 18.8574 9.89736 18.7871 9.57417 18.6768C9.24527 18.5152 9.07797 18.2852 8.88405 17.9601C8.83082 17.8669 8.7909 17.7947 8.77757 17.789C8.26998 18.0989 7.76426 18.4106 7.25666 18.7205C7.50953 19.2395 7.88213 19.6901 8.35932 19.9829C9.07225 20.4106 10.0304 20.5418 11.0323 20.3118C11.6844 20.1217 12.2471 19.7281 12.5418 19.1293C12.9677 18.3441 12.8764 17.3935 12.8726 16.3422C12.8821 14.6274 12.8726 12.9125 12.8726 11.192Z',
      key: '2',
      fill: '#212121',
      strokeWidth: '0',
    },
  ],
])
